import { Button } from "@repo/ui/components/button"

import { useHealth } from "@/lib/use-health"

export function HomePage() {
  const { data, error, isLoading } = useHealth()

  return (
    <div className="flex flex-1 p-6">
      <div className="flex max-w-md min-w-0 flex-col gap-4 text-sm leading-loose">
        <div>
          <h1 className="font-medium">PWA</h1>
          <p>The installable app, running inside the Turborepo workspace.</p>
          <p>
            Shared components come from <code>@repo/ui</code>.
          </p>
          <Button className="mt-2">Button</Button>
        </div>
        <div className="font-mono text-xs text-muted-foreground">
          {isLoading && "checking backend…"}
          {error && `backend unreachable: ${error.message}`}
          {data && `backend ${data.service} ${data.version} — ${data.status}`}
        </div>
        <div className="font-mono text-xs text-muted-foreground">
          (Press <kbd>d</kbd> to toggle dark mode)
        </div>
      </div>
    </div>
  )
}
